import { useState } from "react";
import { CodeBlock, CopyButton, ExternalAnchor } from "./primitives.jsx";

const statusTone = {
  avoid: "badge--crit",
  required: "badge--accent",
  recommended: ""
};

/* A specification packet as a cell: quiet URI chrome, serif title, status badge,
   disclosed code comparison, side effects + verification columns. */
export function SpecPacket({ packet }) {
  const [open, setOpen] = useState(Boolean(packet.bad));
  const hasCode = packet.bad || packet.good;

  return (
    <article id={packet.id} className="packet cell">
      <div className="cell__chrome">
        <span className="packet__uri">{packet.uri}</span>
        <span className={`badge ${statusTone[packet.status] || ""}`}>{packet.status}</span>
      </div>

      <h2 className="packet__title">{packet.title}</h2>
      <p className="packet__summary">{packet.summary}</p>
      <div className="packet__meta">
        <span>Severity · {packet.severity}</span>
        <span>Category · {packet.category}</span>
        <span>Search · {packet.tags.slice(0, 4).join(", ")}</span>
      </div>

      {hasCode ? (
        <>
          <button
            type="button"
            className="disclose"
            aria-expanded={open}
            onClick={() => setOpen((value) => !value)}
          >
            <span>Bad and good practice</span>
            <span className="disclose__chev" />
          </button>
          <div className="disclose-panel" data-open={open ? "" : undefined}>
            <div className="disclose-panel__inner">
              <div className="packet__compare">
                {packet.bad ? (
                  <div>
                    <span className="lbl lbl--crit">Bad</span>
                    <CodeBlock>{packet.bad}</CodeBlock>
                  </div>
                ) : null}
                <div>
                  <span className="lbl lbl--accent">{packet.bad ? "Good" : "Heuristic"}</span>
                  {packet.good?.includes("\n") ? <CodeBlock>{packet.good}</CodeBlock> : <p className="packet__heuristic">{packet.good}</p>}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}

      {packet.diagram ? (
        <div role="img" aria-label={`${packet.title} diagram`}>
          <CodeBlock>{packet.diagram}</CodeBlock>
        </div>
      ) : null}

      <div className="packet__columns">
        <div>
          <span className="lbl">Side effects</span>
          <ul>
            {packet.sideEffects.map((effect) => <li key={effect}>{effect}</li>)}
          </ul>
        </div>
        <div>
          <span className="lbl">Verification</span>
          <ol>
            {packet.verification.map((step) => <li key={step}>{step}</li>)}
          </ol>
        </div>
      </div>

      <footer className="packet__foot">
        <div className="packet__sources">
          {packet.sources.map((source) => (
            <ExternalAnchor key={source.href} href={source.href}>{source.label}</ExternalAnchor>
          ))}
        </div>
        <CopyButton text={packet.checklist}>Copy checklist</CopyButton>
      </footer>
    </article>
  );
}
